import { useNavigate, useSearchParams } from "react-router-dom";
import { isAllowedMobileReturnScheme } from "./mobileReturnScheme";

export const MOBILE_RETURN_SCHEME_KEY = "mobileReturnScheme";
export const MOBILE_AUTH_TOKEN_KEY = "mobileAuthToken";

export const useMobileAppLogin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const rawScheme = searchParams.get("returnScheme") ?? "";
  const returnScheme = rawScheme ? decodeURIComponent(rawScheme) : "";
  const isValid = !!returnScheme && isAllowedMobileReturnScheme(returnScheme);

  const ssoRedirectUrl = isValid ? window.location.origin : "";

  const onAuthSuccess = (authToken: string) => {
    sessionStorage.setItem(MOBILE_RETURN_SCHEME_KEY, returnScheme);
    sessionStorage.setItem(MOBILE_AUTH_TOKEN_KEY, authToken);
    navigate("/mobile-app/success", { replace: true });
  };

  const beginSSOWithReturnScheme = () => {
    if (isValid) {
      sessionStorage.setItem(MOBILE_RETURN_SCHEME_KEY, returnScheme);
    }
  };

  return { isValid, returnScheme, ssoRedirectUrl, onAuthSuccess, beginSSOWithReturnScheme };
};
